// Microphone access helper with specific, actionable error messages.
export async function getMicStream() {
  if (!window.isSecureContext) throw new Error("INSECURE");
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) throw new Error("UNSUPPORTED");
  if (typeof MediaRecorder === "undefined") throw new Error("NORECORDER");
  return navigator.mediaDevices.getUserMedia({ audio: true });
}

export function micErrorMessage(err, lang = "en") {
  const ar = lang === "ar";
  const code = (err && (err.name || err.message)) || "";
  switch (code) {
    case "NotAllowedError":
    case "PermissionDeniedError":
    case "SecurityError":
      return ar
        ? "إذن الميكروفون محظور. اضغط على رمز القفل (أو aA) بجانب شريط العنوان ← الميكروفون ← السماح، ثم أعد المحاولة. وإذا فتحت الرابط من داخل تطبيق آخر، افتحه في Safari أو Chrome."
        : "Microphone permission is blocked. Tap the lock (or aA) icon by the address bar → Microphone → Allow, then retry. If you opened this from inside another app, open it in Safari or Chrome instead.";
    case "NotFoundError":
    case "DevicesNotFoundError":
      return ar ? "لم يتم العثور على ميكروفون في هذا الجهاز." : "No microphone was found on this device.";
    case "NotReadableError":
    case "TrackStartError":
      return ar ? "الميكروفون مستخدَم من تطبيق آخر. أغلق التطبيق الآخر وأعد المحاولة." : "The microphone is in use by another app. Close it and retry.";
    case "UNSUPPORTED":
    case "NORECORDER":
      return ar
        ? "هذا المتصفح لا يدعم تسجيل الصوت هنا. افتح التطبيق مباشرةً في Safari أو Chrome (وليس داخل متصفح تطبيق آخر)."
        : "This browser can't record audio here. Open the app directly in Safari or Chrome — not inside another app's built-in browser.";
    case "INSECURE":
      return ar ? "يتطلب تسجيل الصوت اتصالاً آمناً (HTTPS)." : "Audio recording requires a secure (HTTPS) connection.";
    default:
      return (ar ? "تعذّر الوصول إلى الميكروفون: " : "Couldn't access the microphone: ") + (code || "unknown error");
  }
}
